import React, { useEffect, useState } from 'react'
import { IFile, IReport } from '../../helpers/Interfaces';
import FileUploadUI from '../FileUploadUI/FileUploadUI';
import { getDocumentMedia } from '../../helpers/FirebaseFunctions';

type CompleteReportViewProps = {
    selectedDocument: IReport;
    setShowAlert: CallableFunction;
    setLoading: CallableFunction;
    setAddedFiles: CallableFunction;
    addedFiles: IFile[];
    complete: CallableFunction;
    showAlert: CallableFunction;
}

function CompleteReportView(props: Readonly<CompleteReportViewProps>) {
    const [media, setMedia] = useState([] as IFile[]);
    const [mediaCopy, setMediaCopy] = useState([] as IFile[]);
    const [removedMedia, setRemovedMedia] = useState([] as IFile[]);

    useEffect(() => {
        getMedia(props.selectedDocument.mediaId)
    }, [props.selectedDocument.mediaId])

    function handleMediaInit(docMedia: IFile[]) {
        setMedia(docMedia);
        setMediaCopy(docMedia);
    }

    async function getMedia(mediaId: string) {
        props.setLoading(true);
        await getDocumentMedia(mediaId, handleMediaInit)
        props.setLoading(false);
    }

    async function removeFile(file: IFile) {
        props.setLoading(true);
        let _removedMedia = removedMedia;
        _removedMedia.push(file);
        setRemovedMedia(_removedMedia);

        let _media = media;
        let _filteredArray = _media.filter((_file) => _file !== file);
        setMedia(_filteredArray);
        props.setAddedFiles(_filteredArray);
        props.setLoading(false);
    }

    function addMedia(file: IFile) {
        props.setLoading(true);

        const ext = file.fileName.toLowerCase();
        const isAllowed = ext.endsWith("pdf") || ext.endsWith("doc") || ext.endsWith("docx");

        if (!isAllowed) {
            props.setShowAlert({
                isError: true,
                message: "Only PDF or Word (DOC/DOCX) files are allowed",
                open: true,
            });
            props.setLoading(false);
            return;
        }

        const isDuplicate =
            mediaCopy.some((existing) => existing.fileId === file.fileId) ||
            props.addedFiles.some((existing) => existing.fileId === file.fileId);

        if (!isDuplicate) {
            let newMedia = [...media];
            newMedia.push(file);
            setMedia(newMedia);
            props.setAddedFiles(newMedia);
        }

        props.setLoading(false);
    }

    return (<FileUploadUI setLoading={props.setLoading} setMedia={addMedia} media={media}
        setShowAlert={props.setShowAlert} removeFile={removeFile} showDelete={false} removeMulitpleFiles={() => { }} />)
}

export default CompleteReportView